// removed by extract-text-webpack-plugin
module.exports = {"btn":"button__btn___2om-s","btnFocusable":"button__btn--focusable___77VTd","btnPrimary":"button__btn--primary___3Aos0","btnFlat":"button__btn--flat___34hQF","btnIcon":"button__btn--icon___29g-t"};


//////////////////
// WEBPACK FOOTER
// ./js/components/button/button.scss
// module id = 194
// module chunks = 0 1